import React from 'react';
import {
  Field,
} from 'formik';
import { numToLetter } from '~/commons/helpers';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

const FieldsSingleSelect = ({
  qtnIndex: i,
  question: q,
  answered,
  isCorrect,
  correctAns: cAns,
  disabled = false,
}) => (
  <div>
    {/* answer */}
    {/* {q.choices.map((c, ii) => (
      <div key={ii} className="mb-2">
        <FormCheckGroup
          className="mb-2"
          name={`answers.${i}.answered`}
          type="radio"
          label={`${numToLetter(ii, true)}. ${c}`}
          value={ii.toString()}
          disabled={disabled}
        />
      </div>
    ))} */}
    {q.choices.map(({c, ii},jj) => (
      <div key={ii} className="mb-2">
        <div className="row no-gutters question-choose">
          <div className="col-auto pr-0 form-check">
            <Field 
              id={`rb_${i}_${ii}`} 
              type="radio" 
              className="mb-2 mr-2 form-input" 
              // style={{width: '35px'}} 
              name={`answers.${i}.answered`} 
              value={ii.toString()}
              disabled={disabled}
            />
            <label htmlFor={`rb_${i}_${ii}`} className="form-check-label">{`${numToLetter(jj, true)}.`}</label>
          </div>
          <div className="col pl-1">
            <label htmlFor={`rb_${i}_${ii}`} className="form-check-label">{`${c}`}</label>
          </div>
        </div>
      </div>
    ))}
    {/* answered */}
    {answered !== undefined && (
      <div className={`
        mt-3 py-2 px-4 position-relative
        ${
          cAns !== undefined && !isCorrect
            ? 'bg-light' : 'bg-quinary'
        }
      `}>
        我的答案:
        &nbsp;
        {numToLetter(q.choices.indexOf(q.choices.find(({ii})=>(ii==answered))), true)}
        {/* correct/incorrect mark */}
        {cAns !== undefined && (
          <img
            className="pos-abs-br mr-3 mb-2"
            {...isCorrect ? {
              src: '/assets/img/correct.svg',
              style: { width: '42px', height: '36px' },
            } : {
              src: '/assets/img/incorrect.svg',
              style: { width: '34px', height: '40px' },
            }}
          />
        )}
      </div>
    )}
    {/* correct answer */}
    {(cAns !== undefined && !isCorrect) && (
      <div className="text-tertiary mt-3 py-2 px-4">
        正確答案:
        &nbsp;
        {numToLetter(q.choices.indexOf(q.choices.find(({ii})=>(ii==cAns))), true)}
      </div>
    )}
  </div>
);

export default FieldsSingleSelect;
